export class StringUtils {
  static stringSizeToBytes = (sizeStr: string): number => {
    const units: Record<string, number> = {
      kb: 1024,
      mb: 1024 ** 2,
      gb: 1024 ** 3,
    };

    const value = parseInt(sizeStr);
    const unit = sizeStr.split(String(value))[1]?.toLowerCase();

    if (!unit || !units[unit]) {
      throw new Error('StringUtils.stringSizeToBytes: Unknown size units.');
    }

    return value * units[unit];
  };
}
